<div class="flex flex-col h-full">
	<div class="flex justify-end p-4" *ngIf="pdfUrl">
		<app-button
			icon="download"
			variant="outline"
			(click)="downloadPdf()"
			label="Download"
		/>
	</div>
	<app-e-signing-canvas
		[readonly]="true"
		[recipients]="recipients"
		[pages]="pages"
		[eSigningBlocks]="blocks"
		class="w-full flex-1 border border-gray-200 rounded-lg"
	/>
</div>
